import { TenantProvider } from '@emerald-works-nova/auth'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './app.css'
import './libs/i18n'
import store from './reducers/store'
import * as serviceWorker from './serviceWorker'
import { createTheme } from './theme'
import { ConfirmProvider } from 'material-ui-confirm'
import { ApplicationRouter } from './routes'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={createTheme()}>
      <Provider store={store}>
        <TenantProvider>
          <ConfirmProvider>
            <ApplicationRouter />
          </ConfirmProvider>
        </TenantProvider>
      </Provider>
    </ThemeProvider>
  </StyledEngineProvider>
)

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
